export default {
    props: {
        code: String
    },
    name: 'Flag',
    data() {
        return {
        };
    },
};